// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__tGfJD","detailsBorder":"styles_detailsBorder__2b471"};